import { render } from "./EmployeeShow.vue?vue&type=template&id=10a330dc&scoped=true"
import script from "./EmployeeShow.vue?vue&type=script&lang=js"
export * from "./EmployeeShow.vue?vue&type=script&lang=js"

import "./EmployeeShow.vue?vue&type=style&index=0&id=10a330dc&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a330dc"]])

export default __exports__